import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { ClientsComponent } from './clients/clients.component';
import { ServicesComponent } from './services/services.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

const appRoutes: Routes = [
  {
      path: '',
      pathMatch: 'full',
      component: HomeComponent
  },  
  {
      path: 'home',
      component: HomeComponent
  },
  {
    path: 'about',
    component: AboutUsComponent
},
{
  path: 'services',
  component: ServicesComponent
},
{
  path: 'clients',
  component: ClientsComponent
},
{
  path: 'contact',
  component: ContactUsComponent
},
  ];
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutUsComponent,
    ClientsComponent,
    ServicesComponent,
    ContactUsComponent
  ],
  exports: [RouterModule],

  imports: [
    BrowserModule,RouterModule,
    RouterModule.forRoot(appRoutes),

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
